export default __webpack_public_path__ + "static/media/AR-8.1369faa3.jpg";